import {
	FETCH_AGENDA_BEGIN,
	FETCH_AGENDA_SUCCESS,
	FETCH_AGENDA_ERROR,
	FETCH_AGENDA_RESET,
	FETCH_RDVS_BEGIN,
	FETCH_RDVS_SUCCESS,
	FETCH_RDVS_ERROR,
	POST_RDV_BEGIN,
	POST_RDV_SUCCESS,
	POST_RDV_ERROR,
	POST_RDV_RESET,
	DELETE_RDV_BEGIN,
	DELETE_RDV_SUCCESS,
	DELETE_RDV_ERROR,
	DELETE_RDV_RESET,
} from "../actions/agendaActions"

const initialState = {
	daily_events: {},
	weekly_events: {},
	monthly_events: {},
	fetchAgenda: {
		loading: false,
		error: false,
	},
	// Rendez-vous chargés pour la semaine affichée (liste normalisée).
	rdvs: [],
	fetchRdvs: { loading: false, error: false },
	postRdv: { saving: false, saved: false, error: false },
	deleteRdv: { deleting: false, deleted: false, error: false },
}

export default function agendaReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_AGENDA_BEGIN:
			return {
				...state,
				fetchAgenda: {
					loading: true,
					error: false,
				},
			}
		case FETCH_AGENDA_SUCCESS:
			return {
				...state,
				daily_events: action.payload.daily_events,
				weekly_events: action.payload.weekly_events,
				monthly_events: action.payload.monthly_events,
				fetchAgenda: {
					loading: false,
					error: false,
				},
			}

		case FETCH_AGENDA_ERROR:
			return {
				...state,
				fetchAgenda: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_AGENDA_RESET:
			return {
				...state,
				agenda: {},
				fetchAgenda: {
					loading: false,
					error: false,
				},
			}
		case FETCH_RDVS_BEGIN:
			return { ...state, fetchRdvs: { loading: true, error: false } }
		case FETCH_RDVS_SUCCESS:
			return {
				...state,
				rdvs: action.payload,
				fetchRdvs: { loading: false, error: false },
			}
		case FETCH_RDVS_ERROR:
			return {
				...state,
				fetchRdvs: { loading: false, error: action.payload },
			}
		case POST_RDV_BEGIN:
			return {
				...state,
				postRdv: { saving: true, saved: false, error: false },
			}
		case POST_RDV_SUCCESS:
			return {
				...state,
				postRdv: { saving: false, saved: true, error: false },
			}
		case POST_RDV_ERROR:
			return {
				...state,
				postRdv: { saving: false, saved: false, error: action.payload },
			}
		case POST_RDV_RESET:
			return {
				...state,
				postRdv: { saving: false, saved: false, error: false },
			}
		case DELETE_RDV_BEGIN:
			return {
				...state,
				deleteRdv: { deleting: true, deleted: false, error: false },
			}
		case DELETE_RDV_SUCCESS:
			return {
				...state,
				deleteRdv: { deleting: false, deleted: true, error: false },
			}
		case DELETE_RDV_ERROR:
			return {
				...state,
				deleteRdv: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case DELETE_RDV_RESET:
			return {
				...state,
				deleteRdv: { deleting: false, deleted: false, error: false },
			}
		default:
			return state
	}
}
